module.exports = __webpack_public_path__ + "static/img/p7.9a140cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p7.jpg
// module id = 68
// module chunks = 1